var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.enabled)?_c('div',{staticClass:"g-recaptcha",attrs:{"id":"g-recaptcha","data-sitekey":_vm.recaptchaKey}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }